import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import dayjs from "@gtmhub/dayjs";
import { IGoal } from "@gtmhub/goals/models";
import { ISessionsStoreState } from "@gtmhub/sessions/redux/session-reducer";
import { reduxStoreContainer } from "@gtmhub/state-management/state-management.module";
import { IPlanningSessionsIdMap } from "@webapp/sessions/models/sessions.model";

@Component({
  selector: "single-goal-selector-goals-list",
  templateUrl: "./single-goal-selector-goals-list.component.html",
  styleUrls: ["./single-goal-selector-goals-list.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleGoalSelectorGoalsListComponent implements OnInit {
  @Input() public goals: IGoal[];
  @Input() public unselectableId: string;
  @Input() public sectionTitle: string;
  public sessionsMap: IPlanningSessionsIdMap;

  @Output()
  public readonly goalSelected = new EventEmitter();

  public ngOnInit(): void {
    this.getSessions();
    this.goals = this.goals.filter((goal) => !goal.obfuscated).sort(this.bySessionEndDateDesc);
  }

  private getSessions(): void {
    this.sessionsMap = reduxStoreContainer.reduxStore.getState<ISessionsStoreState>().sessions.map;
  }

  public onGoalSelected(selectedGoal: IGoal): void {
    this.goalSelected.emit(selectedGoal);
  }

  private bySessionEndDateDesc = (a: IGoal, b: IGoal): 0 | 1 | -1 => {
    const aEndDate = dayjs(this.sessionsMap[a.sessionId].end);
    const bEndDate = dayjs(this.sessionsMap[b.sessionId].end);

    if (aEndDate.isBefore(bEndDate)) {
      return 1;
    } else if (aEndDate.isAfter(bEndDate)) {
      return -1;
    }
  };
}
